import { createBrowserRouter } from 'react-router';
import { LazyComponent } from 'components/lazyComponent';
import RouteErrorBoundary from './RouteErrorBoundary';
import Layout from './Layout';
import workflowsRoutes from './workflows/routes';
import secretsRoutes from './secrets/routes';

const NotFoundPage = LazyComponent(() => import('./NotFoundPage'));

const router = createBrowserRouter([{
  path: '/',
  element: <Layout />,
  errorElement: <RouteErrorBoundary />,
  children: [
    ...workflowsRoutes,
    ...secretsRoutes,
    { path: '*', element: <NotFoundPage /> },
  ],
}]);

export default router;
